import React, { useMemo } from 'react';
import { FlatList, TouchableOpacity, View } from '../../../../../components/Common/react-native-components';
import MultiFeatureCard from '../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard';
import MultiSelect from '../../../../Filters/component/MultiSelect';
import get from 'lodash/get';
import ParseMarkdown from '../../../../../components/Common/ParseMarkdown';
import { Icons, Typography } from '@hmsexp/component-library';
import styles from './style';
import ProsConsItem from './ProsConsItem';
import GenericNoData from '../../../../../components/Common/NoData/GenricNoData';
import useRecommendations from './useRecommendations';

const Recommendations = props => {
    const { itemData } = props;

    const {
        selectedProperty,
        setSelectedProperty,
        propertyOptions,
        isLoading,
        data,
        prosConsData,
        activeRecomendationType,
        isProsTabActive,
        onProsConsButtonPress
    } = useRecommendations();
    const isProsConsCardVisible = useMemo(() => {
        return (get(data, 'pros_cons.pros.length', 0) > 0 || get(data, 'pros_cons.cons.length', 0) > 0) && !isLoading;
    }, [data, isLoading])

    return (
        <View>
            <MultiFeatureCard
                title={get(itemData, 'title', '')}
                subTitle={''}
                style={{ childContainer: { minHeight: 250 } }}
                loading={isLoading}
                renderContent={() => {
                    return (
                        <View>
                            <View style={styles.multiSelectContainer}>
                                <MultiSelect
                                    mode='single'
                                    options={propertyOptions}
                                    onSelect={setSelectedProperty}
                                    selected={selectedProperty}
                                />
                            </View>
                            {!isLoading && !data?.recommendations ? (
                                <GenericNoData />
                            ) : (
                                get(itemData, "enableRecommendationSection", false) && <View style={styles.contentContainer}>
                                    <View style={styles.recommendationsContainer}>
                                        <ParseMarkdown>
                                            {data?.recommendations || '---'}
                                        </ParseMarkdown>
                                    </View>
                                </View>
                            )}
                            {isProsConsCardVisible && <View style={styles.prosConsCardContainer}>
                                <View style={styles.prosConsButtonContainer}>
                                    <TouchableOpacity
                                        onPress={() => onProsConsButtonPress('pros')}
                                        style={[styles.prosButton, styles.prosConsButton]}
                                        disabled={get(data, 'pros_cons.pros.length', 0) === 0}
                                    >
                                        <Icons.ThumbsUpIcon />
                                        <Typography>
                                            Pros ({get(data, 'pros_cons.pros.length', 0)})
                                        </Typography>
                                    </TouchableOpacity>
                                    <TouchableOpacity
                                        onPress={() => onProsConsButtonPress('cons')}
                                        style={[styles.consButton, styles.prosConsButton]}
                                        disabled={get(data, 'pros_cons.cons.length', 0) === 0}
                                    >
                                        <Typography>
                                            Cons ({get(data, 'pros_cons.cons.length', 0)})
                                        </Typography>
                                    </TouchableOpacity>

                                </View>
                                <View>
                                    <View
                                        style={[
                                            isProsTabActive ? styles.prosHeader : styles.consHeader,
                                            styles.prosConsHeader
                                        ]}
                                    >
                                        <Typography
                                            textProps={{
                                                style: { color: isProsTabActive ? '#0E4122' : '#D51B25' }
                                            }}
                                        >
                                            {isProsTabActive
                                                ? `Top ${get(data, 'pros_cons.pros.length', 0)} Positive Aspects`
                                                : `Top ${get(
                                                    data,
                                                    'pros_cons.cons.length',
                                                    0
                                                )} Areas for Improvement`}
                                        </Typography>
                                        <Typography
                                            variant='caption'
                                            textProps={{
                                                style: {
                                                    color: isProsTabActive ? '#0E4122' : '#D51B25',
                                                    marginTop: 6
                                                }
                                            }}
                                        >
                                            Based on 100% {isProsTabActive ? 'positive' : 'negative'} mentions
                                        </Typography>
                                    </View>

                                    <FlatList
                                        renderItem={e => (
                                            <ProsConsItem {...e} isProsTabActive={isProsTabActive} />
                                        )}
                                        data={prosConsData}
                                    />
                                </View>
                            </View>}
                        </View>
                    );
                }}
            />



        </View>
    );
};
export default Recommendations;

